import { Chip, Tooltip } from '@mui/material';
import Icon from '../../components/Icon';
import { PrivacyStatus } from '../constants/PrivacyStatus';

interface IsPrivateChipProps {
    isPrivate: string;
}

const IsPrivateChip: React.FC<IsPrivateChipProps> = ({ isPrivate }) => {
    return (
        <Tooltip title={`Public/Private: ${isPrivate === 'true' ? PrivacyStatus.Private : PrivacyStatus.Public}`}>
            <Chip
                icon={<Icon name={isPrivate === 'true' ? PrivacyStatus.Private : PrivacyStatus.Public} />}
                label={isPrivate === 'true' ? PrivacyStatus.Private : PrivacyStatus.Public}
                variant='outlined'
                color='secondary'
            />
        </Tooltip>
    );
};

export default IsPrivateChip;
